import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Obrigado from "./Obrigado";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/obrigado" element={<Obrigado />} />
    </Routes>
  );
}
